// src/HeaderLogo.js
import React from 'react';
import './HeaderLogo.css';

// Define all four logo URLs
const LOGO_SCHLAGE_LIGHT = 'https://yptraining.romancontrols.com/images/romanworks-demo-black.png';
const LOGO_SCHLAGE_DARK = 'https://yptraining.romancontrols.com/images/romanworks-demo-white.png';
const LOGO_ROMANWORKS_LIGHT = 'https://yptraining.romancontrols.com/images/romanworks-trans-black.png';
const LOGO_ROMANWORKS_DARK = 'https://yptraining.romancontrols.com/images/romanworks-trans-white.png';

const HeaderLogo = ({ theme, activeLogo, onToggleLogo }) => {
  let logoSrc;
  
  // Determine the correct logo source based on the active logo set and theme
  if (activeLogo === 'schlage') {
    logoSrc = theme === 'light-mode' ? LOGO_SCHLAGE_LIGHT : LOGO_SCHLAGE_DARK;
  } else {
    logoSrc = theme === 'light-mode' ? LOGO_ROMANWORKS_LIGHT : LOGO_ROMANWORKS_DARK;
  }

  return (
    <img 
      src={logoSrc} 
      alt="Company Logo" 
      className="header-logo" 
      onClick={onToggleLogo} // Add the click handler
      title="Click to toggle logo" // Add a helpful tooltip
    />
  );
};

export default HeaderLogo;